import { getSolvtaxApiOrigin } from "../config/apiBaseUrl";

/**
 * Submit the public contact form to solvtax-api.
 * API emails ADMIN_EMAIL via Mailtrap and sends the user a confirmation.
 */
export async function sendContactForm(data) {
  const url = `${getSolvtaxApiOrigin()}/api/v1/contact`;

  console.log("[API OUTGOING] POST", url, {
    name: data.name,
    email: data.email,
    subject: data.subject,
    messageLength: data.message?.length ?? 0,
  });

  try {
    const response = await fetch(url, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    });

    const result = await response.json().catch(() => ({}));

    if (!response.ok) {
      console.error(`[API ERROR] ${response.status} on ${url}`, {
        requestPayload: {
          name: data.name,
          email: data.email,
          subject: data.subject,
          messageLength: data.message?.length ?? 0,
        },
        responseBody: result,
      });
      let message =
        result?.details || result?.message || `Contact request failed (${response.status})`;
      if (result?.error === "invalid_payload" || result?.error === "validation_failed") {
        message = "Please check your name, email, subject, and message.";
      } else if (result?.error === "turnstile_failed") {
        message = "Security check failed. Please try again.";
      } else if (result?.error === "rate_limit_exceeded") {
        message = "Too many requests. Please try again later.";
      }
      throw new Error(message);
    }

    console.log("[API SUCCESS] contact form accepted", result);
    return { success: true, ...result };
  } catch (error) {
    console.error("[FETCH CRITICAL FAILURE]:", { url, error });
    throw error;
  }
}
